var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "single-column",
    { attrs: { "show-navigation": false, "show-top-bar": false } },
    [
      _c(
        "div",
        { staticClass: "wizard-pad-page" },
        [
          _c("div", { staticClass: "wizard-pad-header" }, [
            _c("div", { staticClass: "va-title" }, [
              _vm._v(" " + _vm._s(_vm.$t("roomWizard.newRoom")) + " ")
            ]),
            _c(
              "div",
              { staticClass: "wizard-pad-actions" },
              [
                _c("info-viewer"),
                _c("light-switcher"),
                _c("va-button", {
                  attrs: { cta: _vm.$t("common.logout") },
                  on: { click: _vm.onLogout }
                })
              ],
              1
            )
          ]),
          _vm.deviceConfiguration == undefined
            ? _c("wizard-connect", {
                attrs: { forceType: true },
                on: {
                  onFetchConfiguration: function($event) {
                    _vm.deviceConfiguration = $event
                  }
                }
              })
            : _c("room-wizard", {
                attrs: {
                  steps: _vm.steps,
                  "device-configuration": _vm.deviceConfiguration,
                  "show-back-to-rooms": false,
                  "calendar-providers":
                    _vm.wizardExternalConfig.calendarProviders,
                  "meeting-providers": _vm.wizardExternalConfig.meetingProviders
                },
                on: { configUpdated: _vm.onConfigUpdated }
              }),
          _c(
            "div",
            { staticClass: "d-flex justify-right mt-6" },
            [
              _vm.deviceConfiguration != undefined
                ? _c("va-button", {
                    attrs: {
                      cta: _vm.$t("roomWizard.reset"),
                      disabled: _vm.deviceConfiguration == undefined
                    },
                    on: {
                      click: function($event) {
                        _vm.deviceConfiguration = undefined
                      }
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }